export default "__VITE_ASSET__yjEmV0gh__"